import type { PublicAgent } from '@magic/schemas/agents';
import { Avatar as TangramAvatar } from '@resultadosdigitais/tangram-components';
import styled from 'styled-components';

const sizes = {
  sm: TangramAvatar.sizes.sm as string,
  md: TangramAvatar.sizes.md as string,
  lg: TangramAvatar.sizes.lg as string,
};

export type Size = keyof typeof sizes;

export interface AvatarProps {
  agent: PublicAgent;
  size?: Size;
  ring?: boolean;
  isBrand?: boolean;
}

const Display = styled(TangramAvatar)`
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Avatar = ({
  agent,
  ring = false,
  size = 'md',
  ...other
}: AvatarProps) => (
  <Display
    {...other}
    size={sizes[size]}
    color={agent.color}
    src={agent.avatar?.url}
    alt={agent.name}
  />
);
